import React, { memo } from 'react';

import FlowerStock from "../../assets/stock/flower.jpg";
import CartridgeStock from "../../assets/stock/cartridge.jpg";
import ConcentrateStock from "../../assets/stock/concentrate.jpg";
import EdibleStock from "../../assets/stock/edible.jpg";
import PrerollStock from "../../assets/stock/preroll.jpg";
import TopicalStock from "../../assets/stock/topical.jpg";
import AccessoryStock from "../../assets/stock/accessory.jpg";

// Define stock images outside the component to avoid recreating on each render
const STOCK_IMAGES = {
    flower: FlowerStock,
    cartridge: CartridgeStock,
    concentrate: ConcentrateStock,
    edible: EdibleStock,
    preroll: PrerollStock,
    topical: TopicalStock,
    accessory: AccessoryStock,
    default: FlowerStock
};

const CATEGORY_MAP = {
    2: 'flower',
    193: 'cartridge',
    350: 'accessory',
    361: 'concentrate',
    371: 'edible',
    424: 'topical',
    402: 'preroll'
};

const LEAFLY_STOCK = "https://leafly-production.imgix.net/https%3A%2F%2Fpublic.leafly.com%2Fweb-dispensary%2Fno_image_disclaimer.svg?dpr=2&h=115&fit=fillmax&s=1af2f84dcb3e7d2293396557fb921cf5";

const ProductImage = ({ product, category, customClass, imgClassName, children }) => {
    if (!category) {
        category = product?.category?.id ?? product.category_id;
    }

    // Get the stock image based on category
    const categoryKey = CATEGORY_MAP[category] || 'default';
    const stockImage = STOCK_IMAGES[categoryKey];

    // Determine which image to show
    const hasValidThumbnail = product.formatted_thumbnail_url && product.formatted_thumbnail_url !== LEAFLY_STOCK;
    const imageUrl = hasValidThumbnail ? product.formatted_thumbnail_url : stockImage;
    const altText = `${product.name} weed deals from ${product?.dispensary_name || ''} pluug cannabis dispensary`;

    return (
        <div className={customClass}>
            <img
                src={imageUrl}
                alt={altText}
                className={imgClassName || ""}
            />
            {children}
        </div>
    );
};

// Export a memoized version of the component
export default ProductImage;
